import {
  clearFilters,
  collapseTableRows,
  returnToLiveTradesForRightClick,
  settingsIconForRightClick,
} from "@/components/icons/SVGIcons";
import historicalSearchStore, {
  returnHistoricalSearch,
} from "@/store/historicalSearchStore";
import { returnToLiveTrades } from "@/store/historicalSearchStoreACTIONS";
import { toggleTradeSettingsPanel } from "../helper/tradeSettingsHelper/toggleTradeSettingsPanel";

// LQC-1885 - only offered while this blotter is showing a historical search.
export const returnToLiveTradesContextMenuItems = (
  cryptoID: string | undefined,
) => {
  const key = cryptoID ?? "";
  const search = returnHistoricalSearch(
    historicalSearchStore.getState().searchByCryptoId,
    key,
  );
  if (!search.viewingHistoricalTable) return [];

  return [
    {
      name: "Return to Live Trades",
      icon: returnToLiveTradesForRightClick,
      action: () => returnToLiveTrades(key),
    },
  ];
};

export const clearAllFiltersContextMenuObject = {
  name: "Clear Filters",
  icon: clearFilters,
  action: (params: any) => {
    params.api.setFilterModel(null);
  },
};

// LQC-1301 — ES-level "Toggle Settings" right-click item. Mirrors the blotter
// settings cog (TradeWideSettingsCellRenderer): opens/closes the left-rail Trade
// Settings panel targeted at the right-clicked trade. Provided so users who
// hide the cog column can still reach the panel. Wrapped in the same
// `tradeSettingsSidebarAndCog` feature flag at the call site.
export const returnToggleSettingsContextMenuObject = (
  params: any,
  cryptoID: string | undefined,
) => ({
  name: "Toggle Settings",
  icon: settingsIconForRightClick,
  action: () => {
    toggleTradeSettingsPanel({
      api: params.api,
      cryptoID,
      esid: params.node?.data?.esid,
    });
  },
});

export const collapseAllExpandedRowsContextMenuObject = {
  name: "Collapse All Expanded Rows",
  icon: collapseTableRows,
  action: (params: any) => {
    params.api.forEachNode((node: any) => {
      if (node.expanded) {
        params.api.setRowNodeExpanded(node, false);
      }
    });
  },
};
